export const RetailerKycDetailsType = {
    //retailer kyc secton

    setRegisterRetailerResponse: 'setRegisterRetailerResponse',
    setPersonalInfo:'setPersonalInfo',
    setSaveData:'setSaveData',
    setROResponse:'setROResponse',
    setBiometricDta:'setBiometricDta',
    setBiometricDtaCaptureStatus:'setBiometricDtaCaptureStatus',
    checkingDriverStatus:'checkingDriverStatus',
    setROId:'setROId',
    setOnboardActiveRoId:'setOnboardActiveRoId',
    setOnboardResponse:'setOnboardResponse',
    setOnboardActiveRoIdMap:'setOnboardActiveRoIdMap',
    setMerchantOnboardStatus:'setMerchantOnboardStatus',
    RESET: "RESET"
}